// document.addEventListener(
//     'DOMContentLoaded',
//     () => {
const blocks = document.querySelectorAll(`.js-bf-block-categories`);

if (blocks.length > 0) {
    blocks.forEach((block) => {
        const posts = block.querySelectorAll(`.js-load-more-post`);
        const loadMoreButton = block.querySelector(`.js-load-more-button`);
        const allButton = block.querySelector(`.js-all-button`);

        if (posts.length > 0) {
            let skip = 6;
            let count = 2;
            const handleClick = () => {
                posts.forEach((post, index) => {
                    const current = index + 1;
                    if (current > skip && current <= skip + count) {
                        post.classList.add('is-active');
                    }
                });
                count += 2;

                const lastActive =
                    posts[posts.length - 1].classList.contains('is-active');

                if (lastActive) {
                    loadMoreButton.style.display = 'none';
                    allButton.classList.add('is-active');
                }
            };

            loadMoreButton.addEventListener('click', handleClick);

            /**
             * toggle post 2 style based on window size
             *
             * @param {boolean} bp mobile or desktop
             */
            const post2Switch = (bp = false) => {
                const post2 = posts[1];
                if (bp) {
                    post2.classList.remove(`layout--image`);
                    post2.classList.add(`layout--horizontal`);
                } else {
                    post2.classList.add(`layout--image`);
                    post2.classList.remove(`layout--horizontal`);
                }
            };

            const bp = 900;
            post2Switch(window.innerWidth <= bp);
            const mql = window.matchMedia(`(max-width: ${bp}px)`);

            mql.addEventListener('change', (e) => {
                post2Switch(e.matches);
            });
        }
    });
}
//     },
//     false
// );
